module.exports = "/fonts/gh-icons.woff2?73e6274e560d19bbe9e3558ab1e13ed3";